<template>
  <vi-popover
    data-testid="app-profile-page-index-7jqxzP"
    placement="right"
    trigger="hover"
    width="298"
    data-tea-expose="appo_default_option_impression"
  >
    <div slot="reference" :class="name">
      <vi-checkbox v-model="isChecked" data-testid="app-profile-page-index-fEzZis" :disabled="disabled">
        {{ $t('module_adgroup_promotion_app_profile_page') }}
      </vi-checkbox>
      <div v-if="isChecked" :class="`${name}__desc`">
        {{
          isAppProfilePageSupportCostCap
            ? $t('module_adgroup_promotion_app_profile_page_switch_desc_no_strategy_limite')
            : $t('module_adgroup_promotion_app_profile_page_switch_description')
        }}
      </div>
    </div>

    <div slot="default" :class="`${name}__hover-content`">
      <div :class="`${name}__hover-img`">
        <img
          src="https://sf16-sg.tiktokcdn.com/obj/eden-sg/nz_zkh_rvarpa/ljhwZthlaukjlkulzlp/ads_manager/img/app-profile-page-demo.gif"
        />
      </div>
      <div :class="`${name}__hover-desc`">
        <span>{{ $t('module_adgroup_promotion_app_profile_page_description') }}</span>
        <a-link :class="`${name}__hover-link`" href="https://ads.tiktok.com/help/article?aid=10007211">
          {{ $t('common_learn_more') }}
        </a-link>
      </div>
    </div>
  </vi-popover>
</template>

<script>
import { defineComponent, computed, toRefs } from '@vue/composition-api';
import { AppProfilePageType } from '@tt4b/ttam-enums';
import { useAllowlist } from '@tt4b/ttam-hooks';
import ALink from '@/components/common/a-link/a-link.vue';
import { trackEvent } from '@/utils';

const name = 'ttam-ios14-switch-app-profile-page';
export default defineComponent({
  name,
  components: {
    ALink,
  },
  model: {
    prop: 'pageType',
    event: 'change',
  },
  props: {
    pageType: {
      type: Number,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { pageType } = toRefs(props);
    const { isAppProfilePageSupportCostCap } = useAllowlist();
    const isChecked = computed({
      get: () => pageType.value === AppProfilePageType.on,
      set: val => {
        if (!val) {
          trackEvent('appo_default_option_uncheck');
        }
        emit('change', val ? AppProfilePageType.on : AppProfilePageType.off);
      },
    });

    return {
      name,
      isAppProfilePageSupportCostCap,
      isChecked,
    };
  },
});
</script>

<style lang="scss">
$name: 'ttam-ios14-switch-app-profile-page';
.#{$name} {
  position: relative;
  z-index: 0;
  margin-top: 8px;
  padding: 24px;
  color: $color-text-primary;
  font-size: 14px;
  line-height: 22px;
  background: $--color-group3-9;
  border-radius: 4px;

  &__desc {
    margin-top: 4px;
    color: $color-text-hint;
    font-size: 12px;
    line-height: 20px;
  }

  &__hover-content {
    display: flex;
  }

  &__hover-img img {
    width: 90px;
    height: 160px;
  }

  &__hover-desc {
    margin-left: 10px;
    color: $color-text-primary;
    text-align: left;
  }

  &__hover-link {
    margin-left: 4px;
  }
}
</style>
